import { useGetFeatureFlags } from '@/hooks/api/tenants/useGetFeatureFlags';
import { useTenants } from '@/services/tenants/useTenants';
import { ReactNode, useMemo } from 'react';
import { FeatureFlagsContext } from './FeatureFlagsContext';

export const FeatureFlagsProvider = ({ children }: { children: ReactNode }) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { isFeatureEnabled } = useGetFeatureFlags(tenantId);

  const contextValue = useMemo(
    () => ({
      isFeatureEnabled,
    }),
    [isFeatureEnabled]
  );

  return <FeatureFlagsContext.Provider value={contextValue}>{children}</FeatureFlagsContext.Provider>;
};
